import { useMutation } from '@apollo/client';
import { REMOVE_COACH_FROM_ATHLETE } from '../../apollo/mutations/athlete';
import { useDispatch } from 'react-redux';
import { removeCoach } from '../../redux/slices/athleteSlice';

const useRemoveCoach = () => {
  const dispatch = useDispatch();

  const [removeCoachMutation, { loading, error }] = useMutation(REMOVE_COACH_FROM_ATHLETE);

  const remove = async (coachId) => {
    try {
      await removeCoachMutation({ variables: { coachId } });
      dispatch(removeCoach(coachId));
    } catch (err) {
      console.error('Error removing coach:', err);
    }
  };

  return { remove, loading, error };
};

export default useRemoveCoach;